<template>
    <!-- 工人月详情批量打印 -->
    <div id="app">
        <el-dialog title="选择需要打印的工人" :visible.sync="showDialog" @close="closeDialog" fullscreen>
            <el-table ref="workerList" :data="workerList" highlight-current-row  @selection-change="selectWorker">
              <el-table-column type="selection"></el-table-column>
              <el-table-column property="username" label="工人姓名" align="center"/>
              <el-table-column property="cardNumber" label="卡号" align="center"/>
            </el-table>
            <span slot="footer">
                <el-button type="primary" @click="printCount" :disabled="printDisabled">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 打印内容 -->
        <el-calendar style="page-break-after:always" v-model="currentMonth" first-day-of-week="7"
            v-for="(item,index) in printArr" :key="index">
            <template slot="dateCell" slot-scope="{date,data}">
                <div @click.stop.prevent="" style="height:100%">
                    <div style="text-align:right;font-size:20px">{{Number(data.day.split('-')[2]) + "号"}}</div>
                    <p style="text-align: center" v-if="isDangChe()">
                        {{dailyDataAdapter(date,item)}}
                    </p>
                    <div v-else>
                      <div style="text-align: center;margin:8px;">{{dailyDataAdapter(date,item).time}}</div>
                      <div style="text-align: center;margin:8px;">{{dailyDataAdapter(date,item).num}}</div>
                    </div>
                </div>
            </template>
        </el-calendar>
    </div>
</template>

<script>
import api from '@/api/factory/statistics/worker'
export default {
    data() {
        return {
            workerList: [],
            selectWorkers: [],
            showDialog: true,
            currentMonth: 0,
            firstTimeForMonth: 0,
            lastTimeForMonth: 0,
            lastDate: 0,
            role: 0,
            // 请求获取后，缓存计算后的数据。
            printCache: {},
            // 根据选择的角色，再从缓存拿数据打印。
            printArr: []
        }
    },
    methods: {
        printCount() {
            var initPrintArr = []
            var _this = this
            this.selectWorkers.forEach(worker => {
                initPrintArr.push(_this.printCache[worker.id])
            })
            this.printArr = initPrintArr
            this.showDialog = false
            setTimeout(() => {
                this.setCalenderTitle()
                window.print()
                this.showDialog = true
                this.printArr = []
            }, 500)
        },
        // 列表选择事件
        selectWorker(selection) {
          this.selectWorkers = selection
        },
        // 获取打印数据
        getWorkerList(role, startTime, endTime) {
            api.getList({ role, startTime, endTime }).then(res => {
                this.initPrintData(res.data)
            })
        },
        // 初始化弹框列表与打印数据
        initPrintData(response) {
            // 按工人ID对返回数据分组
            var groupByWorkerId = this._.groupBy(response, (item) => {
              return item.workerId
            })
            var formatworkerList = []
            var formatPrintCache = {}
            for (var workerId in groupByWorkerId) {
                var workerInfo = groupByWorkerId[workerId]
                // 弹框选择列表
                formatworkerList.push({
                    id: workerInfo[0].workerId,
                    username: workerInfo[0].username,
                    cardNumber: workerInfo[0].cardNumber
                })
                // 打印缓存数据
                var printData = {}
                if (this.isDangChe(workerInfo[0].role)) {
                    printData[workerId] = this.formatDangChe(workerInfo)
                } else {
                    printData[workerId] = this.formatOther(workerInfo)
                }
                this._.assign(formatPrintCache, printData)
            }
            this.workerList = formatworkerList
            this.printCache = formatPrintCache
        },
        // 判断角色是否为挡车工,因为挡车工的工时统计逻辑与其余工种有所差异
        isDangChe(role = '') {
            const realRole = role || this.role
            try {
                return Number(realRole) === this.$enum.roleObj.dangche.value
            } catch (err) {}
        },
        // 格式化挡车工月份的打卡记录
        formatDangChe(data) {
            var groupByDaily = this._.groupBy(data, (info) => {
                return new Date(info.startTime).getDate()
            })
            var dailyData = this._.range(0, this.lastDate, 0)
            var sum = 0
            for (var date in groupByDaily) {
                var oneDay = groupByDaily[date]
                var workingHour = this.computeWorkingHour(oneDay)
                // 如果在html加上小时，- - 和空的都会有
                dailyData[date - 1] = `${this.utils.milliToHour(workingHour)} 小时`
                sum += Number(workingHour)
            }
            dailyData.forEach((item, index) => {
                if (item === 0) { dailyData[index] = this.$params.countEmpty }
            })
            const formatObj = {
                workerId: data[0].workerId,
                username: data[0].username,
                cardNumber: data[0].cardNumber,
                role: data[0].role,
                sumHour: `${this.utils.milliToHour(sum)}`,
                dailyData: this.formatDailyData(dailyData)
            }
            return formatObj
        },
        // 挡车工工时计算逻辑,一天中可能有多次上班 早班，夜班，故将工时计算逻辑抽出。
        computeWorkingHour(oneDay) {
          var sortByTime = this._.sortBy(oneDay, obj => {
            return obj.startTime
          })
          var formatArr = []
          var endTime = sortByTime[0].endTime
          // 时间段，timeslot是个二维数组
          var timeSlot = []
          sortByTime.forEach(item => {
            // if (item.isIgnored) {
            //   return
            // }
            if (item.startTime <= endTime) {
              formatArr.push(item)
              if (item.endTime > endTime) {
                endTime = item.endTime
              }
            } else {
              timeSlot.push(formatArr)
              formatArr = []
              formatArr.push(item)
              endTime = item.endTime
            }
          })
          timeSlot.push(formatArr)
          var sumTime = 0
          timeSlot.forEach(arr => {
            if (arr.length === 0) { return }
            var sortByStart = this._.sortBy(arr, obj => {
              return obj.startTime
            })
            var sortByEnd = this._.sortBy(arr, obj => {
              return obj.endTime
            })
            sumTime += (sortByEnd[sortByEnd.length - 1].endTime - sortByStart[0].startTime)
          })
          return sumTime
        },
        // 按日期对数据进行排序
        formatDailyData(dailyData) {
            var index = 0
            dailyData = this._.groupBy(dailyData, (oneDay) => {
                var date = new Date(this.firstTimeForMonth)
                date = date.setDate(index + 1)
                index++
                return new Date(date).toDateString()
            })
            return dailyData
        },
        // 适配器，日历组件通过date.toDateString为下标找
        dailyDataAdapter(date, item) {
            try {
                const data = item.dailyData[date.toDateString()]
                if (this.isDangChe()) {
                    if (!this.utils.isEmpty(data)) {
                        return data[0]
                    } else {
                        return ''
                    }
                } else {
                    if (!this.utils.isEmpty(data)) {
                        return data[0]
                    } else {
                        return {
                            time: '',
                            num: ''
                        }
                    }
                }
            } catch (error) { console.log(error) }
        },
        // 除挡车工外的工种，按这个方法格式化
        formatOther(response) {
          // 每个工人记录根据日期进行分组
            var groupByDaily = this._.groupBy(response, (info) => {
              return new Date(info.startTime).getDate()
            })
            var sum = 0
            var sumNum = 0
            var max = 0
            var min = 2 * 86400000
            // 每天的次数
            var dailyData = this._.range(0, this.lastDate, 0)
            // 每天的时间
            var dailyTime = this._.range(0, this.lastDate, 0)
            for (var date in groupByDaily) {
              var oneDay = groupByDaily[date]
              sumNum += oneDay.length
              dailyData[date - 1] = oneDay.length
              oneDay.forEach((item) => {
                // if (item.isIgnored) {
                //   sumNum--
                //   dailyData[date - 1]--
                //   return
                // }
                var dValue = item.endTime - item.startTime
                if (dValue > max) {
                  max = dValue
                }
                if (dValue < min) {
                  min = dValue
                }
                dailyTime[date - 1] += dValue
                sum += dValue
              })
            }
            dailyData.forEach((item, index) => {
              dailyTime[index] = this.utils.milliToHour(dailyTime[index])
              if (item === 0) {
                dailyData[index] = { time: this.$params.countEmpty, num: '' }
              } else {
                // dailyData[index] = `${dailyTime[index]}(${dailyData[index]})`
                dailyData[index] = {
                    time: dailyTime[index] + ' 小时',
                    num: dailyData[index] + ' 次'
                }
              }
            })
            const formatObj = {
              machineId: response[0].machineId,
              workerId: response[0].workerId,
              username: response[0].username,
              cardNumber: response[0].cardNumber,
              role: response[0].role,
              sumHour: this.utils.milliToHour(sum),
              maxHour: this.utils.milliToHour(max),
              minHour: this.utils.milliToHour(min),
              avgHour: this.utils.milliToHour(sum / sumNum),
              sumNum,
              dailyData: this.formatDailyData(dailyData)
            }
          return formatObj
        },
        // 设置日历的标题
        setCalenderTitle() {
            this.printArr.forEach((item, index) => {
                var dom = document.getElementsByClassName('el-calendar__title')[index]
                var appendStr = `&nbsp;&nbsp;${item.username}&nbsp;&nbsp;${item.sumHour}小时`
                if (!this.isDangChe()) {
                  appendStr += `&nbsp;&nbsp;${item.sumNum}次`
                }
                dom.innerHTML += appendStr
            })
        },
        closeDialog() {
            if (this.utils.isEmpty(this.printArr)) {
                window.close()
            }
        }
    },
    computed: {
        printDisabled: function() {
            try {
                if (this.selectWorkers.length > 0) {
                    return false
                }
            } catch (err) { console.log(err) }

            return true
        }
    },
    created() {
        const time = this.$route.params.time
        this.role = this.$route.params.role
        this.firstTimeForMonth = this.utils.getFirstTimeByMonth(time)
        this.lastTimeForMonth = this.utils.getLastTimeByMonth(time)
        this.currentMonth = this.firstTimeForMonth
        this.lastDate = new Date(this.lastTimeForMonth).getDate()

        this.getWorkerList(this.role, this.firstTimeForMonth, this.lastTimeForMonth)
    },
    mounted () {
    }
}
</script>

<style lang='scss' scoped>
#app ::v-deep .el-calendar-table .el-calendar-day {
    box-sizing: border-box;
    padding:0px;
    height:95px
}
#app ::v-deep .el-calendar__button-group {
    display: none;
}
#app ::v-deep .el-calendar__title {
  font-size: 20px;
}
</style>
